import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
export function Problema() {
  const problems = ['Te identificas con tu signo, pero sientes que hay algo más profundo.', 'Repites patrones que no sabes explicar.', 'Tu forma de amar, reaccionar y protegerte tiene una raíz.', 'Tu signo no es una etiqueta. Es un arquetipo.'];
  return <section className="py-20 px-6 bg-transparent" data-id="element-273">
      <div className="container mx-auto max-w-5xl" data-id="element-274">
        <AnimatedSection data-id="element-275">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-6" data-id="element-276">
            No es solo tu signo.
          </h2>
          <h3 className="text-2xl md:text-4xl font-serif text-center text-gold-light mb-12" data-id="element-277">
            Es el patrón que se repite detrás de él.
          </h3>
        </AnimatedSection>

        <AnimatedSection delay={0.2} data-id="element-278">
          <p className="text-gray-300 text-lg text-center mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-279">
            Muchas personas conocen su signo, pero nunca han entendido la
            energía que realmente lo mueve...
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-280">
          {problems.map((problem, index) => <AnimatedSection key={index} delay={0.3 + index * 0.1} data-id="element-281">
              <GlowCard className="h-full" data-id="element-282">
                <p className="text-gray-200 text-base leading-relaxed" data-id="element-283">
                  {problem}
                </p>
              </GlowCard>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}